import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sort-order',
  templateUrl: './sort-order.component.html',
  styleUrls: ['./sort-order.component.scss']
})
export class SortOrderComponent implements OnInit {
  @Input('customizedColumns') customizedColumns: any;
  @Input('sortableColumns') sortableColumns: any;
  @Output() sort: EventEmitter<any> = new EventEmitter();
  sortOrders: any = [
    {value: 'asc', label:"Ascending"},
    {value: 'desc', label:"Descending"}
  ];
  sortColumns: any = [
    {value: 'index', label: 'Index'}
  ];
  sortList: any = {};
  constructor() { }

  ngOnInit() {
    this.sortableColumns.forEach(element => {
      if(this.customizedColumns[element.value] != undefined)
      {
        if (this.customizedColumns[element.value].value) {
          this.sortColumns.push(
            {value: element.key, label: this.customizedColumns[element.value].label}
          )
        }
      }
    });
    setTimeout(() => {
      this.sortList.sortColumn = 'index';
      this.sortList.sortOrder = 'desc';
    }, 0);
  }

  sortApply()
  {
    if (this.sortList.sortColumn != undefined && this.sortList.sortOrder != undefined) {
      this.sort.emit(this.sortList);   
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/sort-order/sort-order.component.ts